import { LoadState } from "../../constants/enums";

// ─── Message Types ────────────────────────────────────────────────────────────

export interface IChatMessage {
  id: string;
  role: "user" | "ai";
  content: string;
  timestamp: number;
  isStreaming?: boolean;
  error?: boolean;
}

// ─── API Response Types ───────────────────────────────────────────────────────

export interface IHistoryContentPart {
  text: string;
  type: string;
}

export interface IHistoryContext {
  id: string;
  role: "user" | "ai" | "assistant";
  content: string | IHistoryContentPart[];
}

export interface IHistoryItem {
  agent_converstion_context_id: number;
  message_id: string;
  context: IHistoryContext;
  insert_ts?: string;
}

// ─── Redux State ──────────────────────────────────────────────────────────────

export interface IAiChatState {
  isOpen: boolean;
  messages: IChatMessage[];
  loading: boolean;
  fileContext: string | null;
  history: {
    loading: LoadState;
    error: string | null;
    page: number;
    hasMore: boolean;
  };
}

export const initialAiChatState: IAiChatState = {
  isOpen: false,
  messages: [],
  loading: false,
  fileContext: null,
  history: {
    loading: LoadState.NotLoaded,
    error: null,
    page: 1,
    hasMore: true,
  },
};
